import React, { useState } from "react";

import Container from "@material-ui/core/Container";
import ApplicationPanel from "../application/ApplicationPanel";
import ApplicationHeader from "../application/ApplicationHeader";
import { notBlank } from "../util/ext";
import { useOrganizationSearch } from "./organizationServices";
import OrganizationsBrowse from "./OrganizationsBrowse";
import { Redirect, Route, useHistory, useRouteMatch } from "react-router-dom";
import withAuthorization from "../auth/withAuthorization";
import OrganizationView from "./OrganizationView";

const initialSearchState = {
  appliedFilter: null,
  activeOnly: false,
  orderBy: "organizationName",
  orderDirection: "asc",
  page: 0,
};

const AuthorizedRoute = withAuthorization(Route);

const ManageOrganizationsView = () => {
  const { path } = useRouteMatch();
  const history = useHistory();

  const [searchState, setSearchState] = useState(initialSearchState);
  const searchResults = useOrganizationSearch({
    filter: searchState.appliedFilter,
    order: notBlank(searchState.orderBy)
      ? `${searchState.orderBy}:${searchState.orderDirection}`
      : null,
    page: searchState.page,
    activeOnly: searchState.activeOnly,
  });

  return (
    <Container id="manage-subscriptions" disableGutters>
      <ApplicationHeader />

      <AuthorizedRoute
        exact
        path={`${path}/organizations`}
        roles={["ROLE_ADMIN"]}
      >
        <ApplicationPanel id="application-panel-organizations">
          <OrganizationsBrowse
            searchState={searchState}
            onSearchStateChange={state => setSearchState(state)}
            searchResults={searchResults}
          />
        </ApplicationPanel>
      </AuthorizedRoute>

      <AuthorizedRoute
        exact
        path={`${path}/organizations/:organizationId`}
        roles={["ROLE_ADMIN"]}
      >
        <ApplicationPanel id="application-panel-organization">
          <OrganizationView
            onCancel={() => history.push(`${path}/organizations`)}
          />
        </ApplicationPanel>
      </AuthorizedRoute>

      <Route exact path={path}>
        <Redirect to={`${path}/organizations`} />
      </Route>
    </Container>
  );
};

export default ManageOrganizationsView;
